import api from '../../connections/api';
import routes_api from '../../connections/routes_api';

// View - Frameworks
export const fetchCoreFrameworks = () => {
  return api.get(routes_api.core_frameworks);
};

export const createCoreFramework = (data) => {
  return api.post(routes_api.core_frameworks, data);
};

export const updateCoreFramework = (id, data) => {
  return api.put(`${routes_api.core_frameworks}${id}/`, data);
};

export const deleteCoreFramework = (id) => {
  return api.delete(`${routes_api.core_frameworks}${id}/`);
};

/** Upload framework image (JPEG/PNG/WebP, max 5MB). Field name: file */
export const uploadCoreFrameworkImage = async (frameworkId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(routes_api.core_framework_image(frameworkId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteCoreFrameworkImage = async (frameworkId) => {
  const response = await api.delete(routes_api.core_framework_image(frameworkId));
  return response.data;
};

// View - Cycles (purpose / strategy / tactical — filter by ?horizon=)
export const fetchCoreCycles = (horizon) => {
  const params = horizon ? { horizon } : undefined;
  return api.get(routes_api.core_cycles, { params });
};

export const createCoreCycle = (data) => {
  return api.post(routes_api.core_cycles, data);
};

export const updateCoreCycle = (id, data) => {
  return api.put(`${routes_api.core_cycles}${id}/`, data);
};

export const deleteCoreCycle = (id) => {
  return api.delete(`${routes_api.core_cycles}${id}/`);
};

/** Upload cycle's own image (JPEG/PNG/WebP, max 5MB). Field name: file */
export const uploadCoreCycleImage = async (cycleId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(routes_api.core_cycle_image(cycleId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteCoreCycleImage = async (cycleId) => {
  const response = await api.delete(routes_api.core_cycle_image(cycleId));
  return response.data;
};
